var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2408 10.96H13.6008V21.04H11.6808V22.48H16.9608V21.04H15.0408V10.96H18.4008V12.4H19.8408V10.24C19.8408 10.0491 19.7649 9.86593 19.6299 9.7309C19.4949 9.59588 19.3117 9.52002 19.1208 9.52002H9.52078C9.32983 9.52002 9.14669 9.59588 9.01166 9.7309C8.87664 9.86593 8.80078 10.0491 8.80078 10.24V12.4H10.2408V10.96Z",
    fill: "#6E6E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5997 14.5601V16.4801H17.6797V17.9201H19.5997V20.3201C19.5997 20.8929 19.8273 21.4423 20.2323 21.8474C20.6374 22.2525 21.1868 22.4801 21.7597 22.4801H23.1997V21.0401H21.7597C21.5687 21.0401 21.3856 20.9642 21.2506 20.8292C21.1155 20.6941 21.0397 20.511 21.0397 20.3201V17.9201H22.9597V16.4801H21.0397V14.5601H19.5997Z",
    fill: "#6E6E6E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/Text.e1b127e667ed5dc95b2cc4d807b9694f.svg";
export { ForwardRef as ReactComponent };